
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class EventLogDialog extends SiteEntityDialog<EventLogRow, any> {
        protected getFormKey() { return EventLogForm.formKey; }
        protected getIdProperty() { return EventLogRow.idProperty; }
        protected getLocalTextPrefix() { return EventLogRow.localTextPrefix; }
        protected getNameProperty() { return EventLogRow.nameProperty; }
        protected getService() { return EventLogService.baseUrl; }

        protected form = new EventLogForm(this.idPrefix);

    }
}